import { Card, styled } from '@mui/material';

export const CardWrapper = styled(Card)(({ theme }) => ({
  borderRadius: '20px',
  padding: theme.spacing(1),
  boxShadow: 'none',
  width: '100%',
  maxWidth: '100%',
  boxSizing: 'border-box',

  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0.5),
    borderRadius: '16px',
  },
}));
